import type { ApolloClient, DocumentNode } from '@apollo/client';

export async function fetchGraphqlRecordsByIds<QueryData, RecordType>(
  apolloClient: ApolloClient<object>,
  options: {
    query: DocumentNode;
    variables: Record<string, unknown>;
    selectResults: (data: QueryData | undefined) => RecordType[] | undefined;
  }
): Promise<RecordType[]> {
  const queryResponse = await apolloClient.query<QueryData>({
    query: options.query,
    variables: options.variables,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });

  const results = (options.selectResults(queryResponse.data) ?? []).filter(
    (record): record is RecordType => record != null
  );

  if (results.length === 0 && queryResponse.errors?.length) {
    throw new Error(
      queryResponse.errors[0]?.message ?? 'GraphQL query failed.'
    );
  }

  return results;
}
